import React from 'react';

const InstantBookTapDisplay = (props) => {

    return (
        <span>즉시예약</span>
    );

}

export default InstantBookTapDisplay;